<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      宝安客运站<br>
站点介绍<br>
宝安客运站位于前进二路和西乡大道交叉口,沿前进二路布置。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:37	23:33	12号线	4分钟	8分钟<br>
海上田园东	06:14	23:38	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:42	23:33	12号线	8分钟	8分钟<br>
海上田园东	06:16	23:38	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
前进二路东侧、丽景城、君成雍和园、新庄园小区<br><br>
B出入口:<br>
西乡大道北侧、名典商旅酒店<br><br>
C出入口:<br>
西乡大道北侧、街心公园、彩虹城、金碧实验学校<br><br>
D出入口:<br>
前进二路西侧、宝安交通集团、御龙居、中粮澜山<br><br>
公交换乘信息<br><br>
A、B出入口:<br>
公交站名： 丽景城<br>
718、m371、m425、m313、m209、m250、m393、m131、603、395、m235、高峰专线138<br><br>
D出入口:<br>
公交站名： 宝安客运中心南<br>
m528、高快巴士29、高快巴士60、高快巴士47、605<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>